export default {
	title: "Linhas Espirituais",
	name: "Nome",
	primaryColor: "Cor Principal",
	description: "Descrição",
	create: "Nova Linha Espiritual",
	edit: "Editar Linha Espiritual",
	confirmDeleteMessage: "Tem certeza que deseja excluir a linha espiritual \"{name}\"? Esta ação não pode ser desfeita.",
	stats: {
		total: "Linhas",
	},
	delete: {
		hasLinksWarning: "Esta linha possui {guides} guia(s) e {ritualTypes} tipo(s) de ritual vinculado(s). Eles serão movidos para a linha selecionada antes da exclusão.",
		reassignLabel: "Mover guias e tipos de ritual para",
		reassignAndDelete: "Mover e excluir",
		noTargetLines: "Nenhuma outra linha disponível para reatribuição",
	},
	messages: {
		createSuccess: "Linha espiritual criada com sucesso",
		updateSuccess: "Linha espiritual atualizada com sucesso",
		deleteSuccess: "Linha espiritual excluída com sucesso",
		reassignDeleteSuccess: "Itens reatribuídos e linha espiritual excluída com sucesso",
		createError: "Erro ao criar linha espiritual",
		updateError: "Erro ao atualizar linha espiritual",
		deleteError: "Erro ao excluir linha espiritual",
		loadError: "Erro ao carregar linhas espirituais",
	},
	searchPlaceholder: "Buscar linhas espirituais...",
	noData: "Nenhuma linha espiritual encontrada",
	noDataSubtext: "Comece criando sua primeira linha espiritual",
	searchNoResults: "Nenhuma linha encontrada para '{search}'",
	validation: {
		nameRequired: "Nome é obrigatório",
		nameMaxLength: "Nome deve ter no máximo 100 caracteres",
		descriptionMaxLength: "Descrição deve ter no máximo 500 caracteres",
	},
	form: {
		name: "Nome da Linha",
		description: "Descrição",
		primaryColor: "Cor Principal",
		icon: "Ícone",
	},
};
